'use client';

import { SingleProductPromotion } from '@hyphengroup/cms-components/cms-blocks/SingleProductPromotion';
import type { SingleProductPromotionProps } from '@hyphengroup/cms-components/cms-blocks/SingleProductPromotion/types';
import { LoanSearchParams } from '@hyphengroup/cms-components/utils/searchParams/loanSearchParams';
import { useClientContext } from '../../../../modules/context/client';
import { getLoanSearchParamsWithDefaultComponentParam } from '../../helpers/loanSearchParams';
import { useLoanSearchParams } from '../../helpers/useLoanSearchParams';

export function SingleProductPromotionWrapper(
  props: SingleProductPromotionProps,
) {
  const { vertical, loanSearchParams: initialLoanSearchParams } = props;
  const { brand } = useClientContext();

  const defaultParams =
    vertical === 'PERSONAL_LOANS'
      ? getLoanSearchParamsWithDefaultComponentParam(
          brand,
          initialLoanSearchParams,
        )
      : undefined;

  const { loanSearchParams } = useLoanSearchParams(
    defaultParams ?? ({} as LoanSearchParams),
  );

  return (
    <SingleProductPromotion {...props} loanSearchParams={loanSearchParams} />
  );
}
